import styled from "styled-components";
import { ToastItemStyled } from "app/components/React/Toast/styles";

export const StyledExportToast = styled(ToastItemStyled)`
    align-items: center;

    span {
        padding-right: 40px;
    }
`;
